import { render, staticRenderFns } from "./CharacterSearch.vue?vue&type=template&id=287fc08a&"
import script from "./CharacterSearch.vue?vue&type=script&lang=js&"
export * from "./CharacterSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports